import React, {
    useEffect,
    useState
} from "react";

import {
    FontAwesomeIcon
} from "@fortawesome/react-fontawesome";

import {
    TRUE
} from "../constants/general-constants";

import {
    useHistory
} from "react-router-dom";

import { OMNISCAN_BLUE_SOFT } from "../constants/colors";


export default function DashboardSelectorRow({
    id,
    title,
    url,
    isLive,
    icon,
    collapseFunction
})
{

    //--------------------------------------------------------
    // History
    //--------------------------------------------------------

    const history =
        useHistory();


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [hovered, setHovered] =
        useState(false);

    const [thisOpacity, setThisOpacity] =
        useState("0.9");


    //--------------------------------------------------------
    // Live state
    //--------------------------------------------------------

    useEffect(
        () =>
        {

            if(
                isLive === true
                ||
                isLive === TRUE
            )
            {
                setThisOpacity(
                    "1"
                );
            }
            else
            {
                setThisOpacity(
                    "0.5"
                );
            }

        },
        [id, isLive]
    );


    //========================================================
    // Styles
    //========================================================


    //--------------------------------------------------------
    // Row
    //--------------------------------------------------------

    const thisContainer =
    {
        display:
            "flex",

        width:
            "100%",

        height:
            "44px",

        minHeight:
            "44px",

        boxSizing:
            "border-box",

        alignItems:
            "center",

        paddingLeft:
            "18px",

        paddingRight:
            "18px",

        cursor:
            isLive === true || isLive === TRUE
                ? "pointer"
                : "default",

        opacity:
            thisOpacity,

        /*
         * Solid brighter blue on hover.
         */

        background:
            hovered
                ? "#155987"
                : "transparent",

        /*
         * Square navigation row.
         */

        borderRadius:
            "0px",

        borderBottom:
            "1px solid rgba(141,200,240,0.12)",

        transition:
            "background 0.18s ease"
    };


    //--------------------------------------------------------
    // Icon
    //--------------------------------------------------------

    const iconStyle =
    {
        width:
            "15px",

        height:
            "15px",

        marginRight:
            "14px",

        color:
            hovered
                ? "#ffffff"
                : OMNISCAN_BLUE_SOFT,

        transition:
            "color 0.18s ease"
    };


    //--------------------------------------------------------
    // Title
    //--------------------------------------------------------

    const titleContainer =
    {
        display:
            "flex",

        alignItems:
            "center",

        fontSize:
            "14px",

        fontWeight:
            400,

        color:
            hovered
                ? "#ffffff"
                : "rgba(255,255,255,0.84)",

        transition:
            "color 0.18s ease"
    };


    //========================================================
    // Click
    //========================================================

    const clickFunction =
        () =>
        {

            if(
                isLive !== true
                &&
                isLive !== TRUE
            )
            {
                return;
            }


            if(collapseFunction)
            {
                collapseFunction();
            }


            history.push(
                "/" + url + "/-100"
            );

        };


    //========================================================
    // Render
    //========================================================

    return (

        <div

            style={
                thisContainer
            }

            onClick={
                clickFunction
            }

            onMouseEnter={
                () =>
                {
                    if(
                        isLive === true
                        ||
                        isLive === TRUE
                    )
                    {
                        setHovered(
                            true
                        );
                    }
                }
            }

            onMouseLeave={
                () =>
                {
                    setHovered(
                        false
                    );
                }
            }

        >

            <FontAwesomeIcon
                icon={
                    icon
                }

                style={
                    iconStyle
                }
            />


            <div
                style={
                    titleContainer
                }
            >

                {title}

            </div>

        </div>

    );

}